import dayjs from 'src/utils/dayjs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getCardMovements = serviceBase({
  request: options =>
    axiosClient.get('/cards/movements', {
      params: options
    }),
  retry: 0
});

export const downloadCardMovementsExcel = serviceBase({
  request: options =>
    axiosClient.get('/cards/movements/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `movimientos-de-tarjeta-${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});
